import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_SEARCH_CANDIDATE_ENTRY_PROOF_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../../api';
import { ApiPathParam } from '../../models/SearchParamSchema';
import { PaginatedData } from '../../models/List';

interface PostSearchEntryProofRequest {
  body: {
    q?: string;
    examLevelUuid?: string;
  };
  apiParams: ApiPathParam;
}

export interface PostSearchEntryProofResponse {
  uuid: string;
  candidateId: string;
  name: string;
  examLevels: string;
  entryFormType: string;
  lastUpdateDateTime: string;
}

interface Input {
  onSuccess?: (data: PaginatedData<PostSearchEntryProofResponse>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostSearchEntryProof = ({ onSuccess, onError }: Input) => {
  const postSearchCandidate = async (payload: PostSearchEntryProofRequest) => {
    const res = await axiosClient.post<PaginatedData<PostSearchEntryProofResponse>>(
      POST_SEARCH_CANDIDATE_ENTRY_PROOF_URL(payload.apiParams),
      payload.body
    );
    return res.data;
  };

  return useCustomMutation(postSearchCandidate, {
    onSuccess,
    onError,
  });
};
